export interface FlussCatalogOutput {
    path: string;
    key: string;
    label: string;
    label_key: string;
    type: string;
    referenced_table_name?: string;
    options?: { value: string; label: string }[];
    // Present only on record outputs: the real sys_columns.id (CHOICE options / REFERENCE lookups).
    column_id?: string;
}

export interface FlussCatalogNode {
    node_id: string;
    node_label: string;
    node_type: string;
    label_key?: string;
    outputs: FlussCatalogOutput[];
}

// Single authoring catalog (C7): the anchor record, process variables and the outputs of the
// ancestor nodes, as returned by Fluss::AvailableVariables#catalog.
export interface FlussDataCatalog {
    // The selected node's own outputs (read-only "Saídas" section); never a pickable source.
    self?: FlussCatalogNode | null;
    record: { label_key: string; table?: string | null; outputs: FlussCatalogOutput[] };
    process_variables: { label_key: string; outputs: FlussCatalogOutput[] };
    nodes: FlussCatalogNode[];
}

export const EMPTY_DATA_CATALOG: FlussDataCatalog = {
    self: null,
    record: { label_key: "fluss.data.group.record", table: null, outputs: [] },
    process_variables: { label_key: "fluss.data.group.process_variables", outputs: [] },
    nodes: [],
};

